'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'palette';
var width = 512;
var height = 512;
var aliases = [127912];
var unicode = 'f53f';
var svgPathData = ['M48 256c0 114.9 93.1 208 208 208 2.9 0 5.8-.1 8.6-.2 .8 0 1.2-.2 1.6-.4 .4-.2 1.1-.7 2-1.8 1.9-2.3 3.8-6.5 3.8-11.8 0-1.7-.6-5.6-5.6-17.1-.5-1.2-1.2-2.7-1.9-4.3-4.2-9.5-11.1-25-14.4-40.6-1.4-6.4-2.1-13.1-2.1-19.8 0-53 43-96 96-96l97.9 0c7.7 0 14.1-2.7 17.8-5.8 3.3-2.7 4.2-5.3 4.2-8 0-.7 0-1.4 0-2.2 0-114.9-93.1-208-208-208S48 141.1 48 256zm112 0a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm32-96a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96-32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0zm96 32a32 32 0 1 1 -64 0 32 32 0 1 1 64 0z', 'M464 258.2c0 2.7-1 5.2-4.2 8-3.8 3.1-10.1 5.8-17.8 5.8L344 272c-53 0-96 43-96 96 0 6.8 .7 13.4 2.1 19.8 3.3 15.7 10.2 31.1 14.4 40.6l0 0c.7 1.6 1.4 3 1.9 4.3 5 11.5 5.6 15.4 5.6 17.1 0 5.3-1.9 9.5-3.8 11.8-.9 1.1-1.6 1.6-2 1.8-.3 .2-.8 .3-1.6 .4-2.9 .1-5.7 .2-8.6 .2-114.9 0-208-93.1-208-208S141.1 48 256 48 464 141.1 464 256c0 .7 0 1.4 0 2.2zm48 .5c0-.9 0-1.8 0-2.7 0-141.4-114.6-256-256-256S0 114.6 0 256 114.6 512 256 512c3.5 0 7.1-.1 10.6-.2 31.8-1.3 53.4-30.1 53.4-62 0-14.5-6.1-28.3-12.1-42-4.3-9.8-8.7-19.7-10.8-29.9-.7-3.2-1-6.5-1-9.9 0-26.5 21.5-48 48-48l97.9 0c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPalette = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;